import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/shared";
import { useSettings } from "@/context/SettingsContext";

export default function Privacy() {
  const { settings } = useSettings();
  return (
    <>
      <SEO title="Privacy Policy | BJRC" description="Brackenfell Junior Rugby Club privacy policy and POPIA commitments." />
      <PageHero title="Privacy Policy" />
      <section className="mx-auto max-w-3xl space-y-5 px-4 py-14 text-slate-700 sm:px-6 lg:px-8">
        <p>Brackenfell Junior Rugby Club (BJRC) is committed to protecting your personal information in line with the Protection of Personal Information Act (POPIA).</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Information We Collect</h2>
        <p>We only collect the information you provide through our enquiry forms (name, email, phone number and your message). We do not collect unnecessary personal information.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">How We Use It</h2>
        <p>Your information is used solely to respond to your enquiry and to administer club membership and communication. Access is restricted to authorised club administrators.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Children's Privacy</h2>
        <p>We do not publish children's personal details or photographs without appropriate parental/guardian authorisation.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Retention &amp; Your Rights</h2>
        <p>We retain enquiry data only as long as needed. You may request access to, correction of, or deletion of your information at any time.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Contact</h2>
        <p>For any privacy requests, contact us at {settings?.email_admin || "admin@brackenfelljuniorrugby.co.za"}.</p>
      </section>
    </>
  );
}
